import React from 'react';

import MediaLayoutContainer from '../../../styling/layout-containers/MediaLayoutContainer';
import MediaDisplay from '../../Common/MediaDisplay';

function BaseMediaContainer(props) {
  const { mediaColumnSizing, layout, media, imageSize } = props;

  return (
    <MediaLayoutContainer {...mediaColumnSizing} layout={layout}>
      <MediaDisplay media={media} imageSize={imageSize} layout={layout} />
    </MediaLayoutContainer>
  );
}

export default BaseMediaContainer;
